import { IconRedirect } from 'src/Assets/svg';
import { externalPath } from 'src/Config';
import { Link } from 'src/shared/Link';
import { i18, trb } from 'src/Utilities';

export const TermsOfService = () => {
  const language = localStorage.getItem('language');

  const label = trb(i18.Labels.TermsOfService);

  return (
    <Link
      className="login_footer_text d-flex align-items-center lh-1"
      to={externalPath[language === 'en-GB' ? 'smeBankGeneralAgreementsEn' : 'smeBankGeneralAgreements']}
      id="termsOfServiceButton"
      target="_blank"
      aria-label={label}
    >
      <span>{label}</span>
      <span
        className="ml-1"
        aria-hidden="true"
      >
        <IconRedirect size={20} />
      </span>
    </Link>
  );
};
